import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GenericService } from './generic.service';
import { PwaModel as PWA } from '../models/pwa.model';

@Injectable({
	providedIn: 'root',
})
export class PwaService extends GenericService<PWA> {
	private http1 = inject(HttpClient);

	constructor() {
		super();

		this.endpoint = 'pwa';
		this.ACTIONS = {
			list: 'PWA_LIST',
			add: 'PWA_ADD',
			update: 'PWA_UPDATE',
			delete: 'PWA_DELETE',
			item: 'PWA_ITEM',
		};
	}

	getManyCompanyPwa = (companyUuid: string, params: any = {}) => {
		this.endpoint = `companies/${companyUuid}/pwa`;
		return super.list(params);
	};

	postOneCompanyPwa = (companyUuid: string, pwa: PWA) => {
		this.endpoint = `companies/${companyUuid}/pwa`;
		return super.add(pwa);
	};

	patchOneCompanyPwa = (companyUuid: string, pwaUuid: string, pwa: Partial<PWA>) => {
		this.endpoint = `companies/${companyUuid}/pwa/${pwaUuid}`;
		return super.patch(pwa);
	};

	deleteOneCompanyPwa = (companyUuid: string, pwaUuid: string) => {
		this.endpoint = `companies/${companyUuid}/pwa`;
		return super.delete(pwaUuid);
	};
}
